import { Component, computed, input, OnDestroy, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { LANGUAGES } from '../constants/languages';

@Component({
  selector: 'app-language-select',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatIconModule,
    MatSelectModule,
    MatFormFieldModule
  ],
  templateUrl: './language-select.component.html',
  styleUrl: './language-select.component.scss'
})
export class LanguageSelectComponent implements OnDestroy {
  small = input<boolean>(false);

  selectControl = new UntypedFormControl();
  changeSub?: Subscription;

  $langs = signal(LANGUAGES);
  $langsOptions = computed(() =>
    this.$langs().map((lang) => ({ value: lang.code, label: lang.localName }))
  );

  constructor(private translate: TranslateService) {
    // Initialize control with current language
    this.selectControl.setValue(this.translate.currentLang || this.translate.defaultLang, { emitEvent: false });

    // Listen to control changes and update language
    this.changeSub = this.selectControl.valueChanges.subscribe((langCode: string) => {
      this.setLanguage(langCode);
    });
  }

  ngOnDestroy() {
    if (this.changeSub) {
      this.changeSub.unsubscribe();
    }
  }

  setLanguage(langCode: string) {
    this.translate.use(langCode);
    // Store preference in localStorage
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem('NG_TRANSLATE_LANG_KEY', langCode);
      // Reload page to apply new locale (date formatting, etc.)
      window.location.reload();
    }
  }
}
